import React from 'react';
import Payment from './Payment';
import TabsHeader from '@shared/components/TabsHeader';

const HotelBookingDone = () => {
  return (
    <>
      <TabsHeader site={1} />
      <Payment />
    </>
  );
};

export default HotelBookingDone;
